import { useCallback } from 'react';

import { useInternalRedirect } from '@/features/redirect';
import { useCommonErrorDialog } from '@/hooks/useCommonErrorDialog';

/**
 * PTID期限切れ カスタムフック
 */
export const usePtidExpired = () => {
  const { resetState } = useCommonErrorDialog();
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * PTID期限切れ
   */
  const ptidExpired = useCallback(() => {
    // ようこそ画面に遷移。このとき表示中だった画面パスは指定不要(再ログイン後、一律ホーム画面を表示)
    internalRedirectToWelcome();
    // エラーダイアログの情報をリセット
    resetState();
  }, [internalRedirectToWelcome, resetState]);

  return {
    ptidExpired,
  };
};
